import React, { useCallback } from "react";
import { Flex, useMultiStyleConfig, Text } from "@chakra-ui/react";
import DownloadPriceModalFileTypeSelector from "@/components/DownloadPriceModal/FileSelector/DownloadPriceModalFileTypeSelector";
import { htmlify } from "@/services/utils";

interface DownloadAllocationModalBodyStageOneProps {
	supportedFileTypes: string[];
	handleFileTypeChange: (fileType: string) => void;
	selectedFileType: string | undefined;
	translations?: { [key: string]: string };
}
function DownloadAllocationModalBodyStageOne({
	supportedFileTypes,
	handleFileTypeChange,
	selectedFileType,
	translations
}: DownloadAllocationModalBodyStageOneProps) {
	const coreStyleParts = useMultiStyleConfig("DownloadAllocationModalBodyCore");
	const styleParts = useMultiStyleConfig("DownloadAllocationModalBodyStageOne");
	const handleClick = useCallback(
		(f: string) => {
			return () => {
				return handleFileTypeChange(f);
			};
		},
		[handleFileTypeChange]
	);
	return (
		<Flex sx={coreStyleParts.root}>
			<Flex sx={coreStyleParts.titleContainer}>
				<Text sx={coreStyleParts.titleText}>{htmlify(translations?.selectFileType)}</Text>
				<Text sx={coreStyleParts.descriptionText}>{htmlify(translations?.selectFileTypeDescription)}</Text>
			</Flex>
			<Flex sx={styleParts.fileTypeContainer}>
				{supportedFileTypes.map((fileType) => {
					return (
						<DownloadPriceModalFileTypeSelector
							onClick={handleClick(fileType)}
							key={fileType}
							fileType={translations && translations[fileType]}
							isSelected={selectedFileType === fileType}
						/>
					);
				})}
			</Flex>
		</Flex>
	);
}

export default DownloadAllocationModalBodyStageOne;
